import { DevotionalElement } from 'grow.client';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import produce from 'immer';
import { useAppDispatch } from '../../../../../store/store';
import { setDevotionalElement } from '../../../../../store/slices/devotionalBuilderSlice/devotionalBuilderHistorySlice';

interface Props {
    devotionalElement: DevotionalElement
}

export const TitleSettings: React.FC<Props> = ({ devotionalElement }) => {
    const dispatch = useAppDispatch();
    const titleElement = devotionalElement.titleElement;

    const setText = (value: string) => {
        const updatedDevotionalElement = produce(devotionalElement, draft => {
            if (!draft.titleElement) return;
            draft.titleElement.text = value;
        });
        dispatch(setDevotionalElement(updatedDevotionalElement));
    }

    return (
        <div>
            <FormControl fullWidth margin="normal">
                <TextField
                    id="text"
                    label="Text"
                    onChange={(e) => setText(e.target.value)}
                    value={titleElement?.text}
                    variant="standard"
                    autoFocus
                    inputProps={{
                        spellCheck: true
                    }}
                />
            </FormControl>
        </div>
    );
}